///////////////////////////////////////////////////

import { ofType } from 'redux-observable';
import { merge } from 'rxjs';
import { filter, map, take, withLatestFrom } from 'rxjs/operators';
import {
  secondaryMarketProductsColumnsFetching,
  secondaryMarketProductsPreferenceStateGet,
  secondaryMarketProductsSearchedCodesFetching,
} from 'state/secondaryMarket/productSearch';
import type { EpicWithThunk } from 'state/state.common';
import { getWorkspaceActiveTabId } from 'state/workspaces/workspaces/workspaces.selector';

export function initializeEpic(): EpicWithThunk {
  return (actions$, state$) => {
    const productSearch$ = actions$.pipe(
      ofType(
        'WORKSPACE_TABS_FETCHED',
        'WORKSPACE_TAB_UNACTIVATED',
        'WORKSPACE_TABS_ALL_REMOVED',
        'WORKSPACE_TAB_REMOVED',
      ),
      filter(t => t.workspace === 'secondaryMarketQuotes'),
      withLatestFrom(state$),
      filter(([_, state]) => getWorkspaceActiveTabId(state, 'secondaryMarketQuotes') === undefined),
    );

    const columnFetching$ = productSearch$.pipe(
      take(1),
      map(_ => secondaryMarketProductsColumnsFetching()),
    );
    const columnStateFetching$ = productSearch$.pipe(map(_ => secondaryMarketProductsPreferenceStateGet()));
    const dataFetching$ = productSearch$.pipe(
      take(1),
      map(_ => secondaryMarketProductsSearchedCodesFetching()),
    );

    return merge(columnFetching$, columnStateFetching$, dataFetching$);
  };
}
